import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { get } from 'lodash'
import { useSnackbar } from 'notistack'
import { Button, CircularProgress, Container } from '@material-ui/core'

import StepCard from '../../components/cards/StepCard/StepCard'
import ClientHeader from '../../sections/headers/ClientHeader/ClientHeader'
import usePrevious from '../../components/hooks/usePrevious'
import { fetchData } from '../../api/api'
import CustomTable from '../../components/table/CustomTable'
import clientTicketStyles from './css/clientTicketStyles'

const headCellsSku = [{ id: 'id', numeric: false, order: false, label: 'Código de producto' }]

const createSkuRows = ({ id = '-' }) => {
  return { id }
}

const testRows = [
  {
    id: '20485641890',
  },
  {
    id: '20485641891',
  },
  {
    id: '20485641892',
  },
  {
    id: '20485641893',
  },
]

const ClientTicket = ({ location }) => {
  const classes = clientTicketStyles()
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()

  const searchData = get(location, 'state')
  const view = 'chooseProduct'

  const [isLoading, setIsLoading] = useState(false)

  const [tableRows, setTableRows] = useState([])
  const [curretPage, setCurrentPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('id')
  const [numberOfPages, setNumberOfPages] = useState(1)
  const [isDataLoading, setIsDataLoading] = useState(false)

  const prevSearchData = usePrevious(searchData)

  useEffect(() => {
    const fetchFormData = async () => {
      setIsDataLoading(true)
      try {
        const tableDataApi = await fetchData({ ...searchData, rowsPerPage, curretPage })
        setNumberOfPages(get(tableDataApi, 'pages.total') || 1)
        setTableRows(
          (get(tableDataApi, 'data') || []).map(row =>
            createSkuRows({
              id: get(row, 'id'),
              date: get(row, 'price'),
              view,
            })
          )
        )

        return setIsDataLoading(false)
      } catch (error) {
        setIsDataLoading(false)
        return error
      }
    }
    // if (!isEqual(prevSearchData, searchData)) fetchFormData()
  }, [prevSearchData, searchData])

  const handleConfirmClick = () => {
    return history.push({
      pathname: 'ticket',
    })
  }

  return (
    <div className={classes.root}>
      <Container maxWidth="md" className={classes.container}>
        <ClientHeader
          title="Confirma tu selección"
          subTitle="¿Estos son los productos que quieres cambiar o devolver?"
          step="3"
          totalSteps="3"
        />

        <StepCard hideSteps>
          <div className={classes.tableContainer}>
            <CustomTable
              className={classes.table}
              rows={testRows}
              headCells={headCellsSku}
              actionTable
              eraseButton
              page={curretPage}
              setPage={setCurrentPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              order={order}
              setOrder={setOrder}
              orderBy={orderBy}
              setOrderBy={setOrderBy}
              isDataLoading={isDataLoading}
              numberOfPages={numberOfPages}
              hidePagination
            />

            <Button
              fullWidth
              size="large"
              variant="outlined"
              color="primary"
              onClick={() => {
                history.goBack()
              }}
              style={{ height: 56 }}
              className={classes.button}
            >
              VOLVER A ELEGIR PRODUCTOS
            </Button>
            <Button
              fullWidth
              size="large"
              variant="contained"
              color="primary"
              style={{ height: 56 }}
              onClick={handleConfirmClick}
            >
              {isLoading ? <CircularProgress /> : 'CONFIRMAR SELECCIÓN'}
            </Button>
          </div>
        </StepCard>
      </Container>
    </div>
  )
}

export default ClientTicket
